import * as yup from "yup";

const DEFAULT_MESSAGE = "Este campo es requerido."

const userSchema = yup.object().shape({
    name: yup.string().required(DEFAULT_MESSAGE),
    email: yup.string().email("Escriba un email válido").required(DEFAULT_MESSAGE),
    profile: yup.number().min(1, DEFAULT_MESSAGE).required(DEFAULT_MESSAGE),
    active: yup.number().required(DEFAULT_MESSAGE),
    password: yup
        .string(),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password')], 'Las contraseñas deben coincidir.')
});

export {
    userSchema
}